/**
 * URL segment builder for the backend's multi-menu/area path contract, shared
 * by search-all-hours and calendar-availability-new:
 *   no filters  → ''            menus only → '/1-3'
 *   areas only  → '/-/2-4'      both       → '/1-3/2-4'
 * '-' is the backend's no-menu sentinel (getMenuIds() treats '-'/null as empty).
 * Ids are joined in the order given — callers sort before storing when a
 * stable cache key matters (see timeSlotsKeys / SelectAreaFilterPage).
 */
export function sanitizeIds(ids: number[] | null | undefined): number[] {
  if (!ids || ids.length === 0) return [];
  return ids.filter((id) => Number.isInteger(id) && id > 0);
}

export function buildMenuAreaSegments(
  menuFilter?: number[] | null,
  areaFilter?: number[] | null,
): string {
  const menus = sanitizeIds(menuFilter);
  const areas = sanitizeIds(areaFilter);
  if (menus.length > 0 && areas.length > 0) return `/${menus.join('-')}/${areas.join('-')}`;
  if (menus.length > 0) return `/${menus.join('-')}`;
  if (areas.length > 0) return `/-/${areas.join('-')}`;
  return '';
}
